<div class="flex flex-row">
  <div class="font-semibold mr-1 text-md">{{ fieldDef.label }}:</div>
  @if (fieldDef.meta?.value_hidden) {
    <div class="text-md">{{ value }}</div>
  } @else {
    <div class="text-md">{{ value | date: 'MM/dd/yyyy' }}</div>
  }
</div>
